import React, { Component } from 'react';  
import { setStorage, getStorage } from '../../common'; 
import { connect } from 'react-redux';
import NavigatorMain from '../NavigatorMain.js';
import { Toast } from 'antd-mobile/lib';
import { hashHistory } from 'react-router';
import NullView from "../NullView.js";

let rotateInterval;

class Recommend extends Component {
  state = {
    rotateNum: 0
  }

  componentWillMount() {
    document.getElementsByTagName('title')[0].innerHTML = "查理推荐";
    let thisO = this;
    rotateInterval = setInterval(() => {
      thisO.setState({
        rotateNum: thisO.state.rotateNum+1
      })
    }, 10);
  }

  componentWillUnmount() {
    clearInterval(rotateInterval);
  }

  goBack = () => {
     hashHistory.goBack();
  }

  knowMore = () => {
    hashHistory.push({
      pathname: "/knowMore",
      state: {
        content: "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。"
      }
    });
  }

  goEncyclopedia = () => {
    hashHistory.push({
      pathname: "/encyclopedia"
    });
  }

  goMain = () => {
    hashHistory.push({
      pathname: "/nullView"
    });
  }

  goFundDetail = (code, type) => {
    hashHistory.push({
      pathname: "/SuperFundDetail",
      state:{
        superFundCode: code
      },
      query:{
        superFundCode: code
      }
    });
  }

  render() {
    let knowMoreText = "";
    let titleText = "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。";
    let titleTextStr = "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。";
    if(window.winWidth > 375 &&  window.winWidth <= 414) {
      titleTextStr = "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。";
    }else if(window.winWidth <= 375 && window.winWidth > 320) {
      titleTextStr = "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。";
    }else if(window.winWidth == 320) {
      titleTextStr = "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段...";
      knowMoreText = "了解更多 >>";
    }else if(window.winWidth > 414 && window.winWidth <= 480) {
      titleTextStr = "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。";
    }else if(window.winWidth > 480 && window.winWidth <= 540) {
      titleTextStr = "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。";
    }
    return (
        <div style={{backgroundSize: "cover", backgroundImage: `url(${require("../../img/clbsBg.jpg")})`, display: "-webkit-flex", WebkitFlexDirection: "column", height: "100%"}}>
          <NavigatorMain>
            <div style={{display: "-webkit-flex", height: 44, WebkitAlignItems: "center", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between"}}>
              <div style={{width: 100}}>
                <img onClick={this.goBack}  alt="" style={{height: 40, width: 40}} src={require("../../img/leftArrow_header.png")} />
              </div>
              <div style={{fontSize: 15, color: "#fff", WebkitFlex: 1, textAlign: "center"}}>查理推荐</div>
              <div onClick={this.goEncyclopedia} style={{fontSize: 15, color: "#fff", paddingRight: 13, width: 100, textAlign: "right"}}>智投百科</div>
            </div>
          </NavigatorMain>
          <div style={{WebkitFlex: 1, overflow: "auto", overflowX: "hidden"}}>
            <div style={{
              width: window.winWidth,
              paddingLeft: 13,
              paddingRight: 13,
              WebkitFlexDirection: "row",
              WebkitJustifyContent: "space-between",
              WebkitAlignItems: "center",
              display: "-webkit-flex",
              paddingTop: 20,
              paddingBottom: 20
            }}>
              <img alt="" style={{height: 63, width: 63}} src={require("../../img/jqrIcon.png")} />
              <div style={{position: "relative", paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth-96, borderRadius: 10}}>
                <span style={{
                  color: "#fff",
                  lineHeight: "16px",
                  fontSize: 13
                }}>{titleTextStr}</span>
                <div onClick={() => this.knowMore(titleText)} style={{position: "absolute", right: 10, bottom: 8}}><span style={{color: "#fa063a", fontSize: 14}}>{knowMoreText}</span></div>
              </div> 
            </div>
            <div>
              <div style={{position:"relative", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", margin: "0 auto", backgroundSize: "cover", height: window.winWidth === 320 ? window.winWidth-46 : window.winWidth-76, width: window.winWidth === 320 ? window.winWidth-46 : window.winWidth-76, backgroundImage: `url(${require("../../img/round_bs.png")})`}}>
                <img alt="" style={{height: 70, width: 70, margin: "0"}} src={require("../../img/clbs_head.png")} />
                <img alt="" style={{transform: "rotate(" + this.state.rotateNum + "deg)", position: "absolute", height: window.winWidth === 320 ? window.winWidth-46 : window.winWidth-76, width: window.winWidth === 320 ? window.winWidth-46 : window.winWidth-76, left: 0, top: 0}} src={require("../../img/smRound.png")} />
                <div onClick={()=> this.goFundDetail("SF1009", "教育")} style={{textAlign: "center", position: "absolute", top: 0, left: window.winWidth === 320 ? (window.winWidth-46)/2-50 : (window.winWidth-76)/2-50}}>
                  <img alt="" style={{height: 35, width: 35}} src={require("../../img/slxx.png")} />
                  <div style={{fontSize: 10, color: "#fff", textAlign: "center"}}>金色起跑线</div>
                </div>
                <div onClick={()=> this.goFundDetail("SF1006", "养老")} style={{textAlign: "center", position: "absolute", top: 20, left: window.winWidth === 320 ? (window.winWidth-46)/2 : (window.winWidth-76)/2}}>
                  <img alt="" style={{height: 35, width: 35}} src={require("../../img/60s.png")} />
                  <div style={{fontSize: 10, color: "#fff", textAlign: "center"}}>60后智享财富</div>
                </div>
                <div onClick={()=> this.goFundDetail("SF1005", "风险")} style={{textAlign: "center", position: "absolute", top: window.winWidth === 320 ? (window.winWidth-46)/2-80 : (window.winWidth-76)/2-80, left: window.winWidth === 320 ? (window.winWidth-46)/2-100 : (window.winWidth-76)/2-100}}>
                  <img alt="" style={{height: 40, width: 40}} src={require("../../img/jq.png")} />
                  <div style={{fontSize: 10, color: "#fff", textAlign: "center"}}>锐意进取</div>
                </div>
                <div onClick={()=> this.goFundDetail("SF1008", "养老")} style={{textAlign: "center", position: "absolute", top: window.winWidth === 320 ? (window.winWidth-46)/2-100 : (window.winWidth-76)/2-100, right: -10}}>
                  <img alt="" style={{height: 50, width: 50}} src={require("../../img/80s.png")} />
                  <div style={{fontSize: 10, color: "#fff", textAlign: "center"}}>80后智领未来</div>
                </div>
                <div onClick={()=> this.goFundDetail("SF1010", "教育")} style={{textAlign: "center", position: "absolute", top: window.winWidth === 320 ? (window.winWidth-46)/2 : (window.winWidth-76)/2, left: -10}}>
                  <img alt="" style={{height: 40, width: 40}} src={require("../../img/cqt.png")} />
                  <div style={{fontSize: 10, color: "#fff", textAlign: "center"}}>菁英中学生</div>
                </div>
                <div onClick={()=> this.goFundDetail("SF1007", "养老")} style={{textAlign: "center", position: "absolute", top: window.winWidth === 320 ? (window.winWidth-46)/2+40 : (window.winWidth-76)/2+40, left: window.winWidth === 320 ? (window.winWidth-46)/2-80 : (window.winWidth-76)/2-80}}>
                  <img alt="" style={{height: 40, width: 40}} src={require("../../img/70s.png")} />
                  <div style={{fontSize: 10, color: "#fff", textAlign: "center"}}>70后智赢人生</div>
                </div>
                <div onClick={()=> this.goFundDetail("SF1011", "教育")} style={{textAlign: "center", position: "absolute", bottom: -20, left: window.winWidth === 320 ? (window.winWidth-46)/2 : (window.winWidth-76)/2}}>
                  <img alt="" style={{height: 50, width: 50}} src={require("../../img/hf.png")} />
                  <div style={{fontSize: 10, color: "#fff", textAlign: "center"}}>常青藤大学</div>
                </div>
                <div onClick={()=> this.goFundDetail("SF1003", "风险")} style={{textAlign: "center", position: "absolute", top: window.winWidth === 320 ? (window.winWidth-46)/2-20 : (window.winWidth-76)/2-20, right: 0}}>
                  <img alt="" style={{height: 35, width: 35}} src={require("../../img/jh.png")} />
                  <div style={{fontSize: 10, color: "#fff", textAlign: "center"}}>均衡稳健</div>
                </div>
                <div onClick={()=> this.goFundDetail("SF1002", "风险")} style={{textAlign: "center", position: "absolute", top: window.winWidth === 320 ? (window.winWidth-46)/2+60 : (window.winWidth-76)/2+60, right: 10}}>
                  <img alt="" style={{height: 40, width: 40}} src={require("../../img/wj.png")} />
                  <div style={{fontSize: 10, color: "#fff", textAlign: "center"}}>安逸理财</div>
                </div>
              </div>
            </div>
            <div style={{paddingBottom: 10}}>
              <div onClick={this.goMain} style={{margin: "0 auto", marginBottom: 40, marginTop: 50, height: 40, borderRadius: 25, border: "1px solid #fff", fontSize: 14, width: 209, background: "transparent", color: "#fff", WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex"}}>
                  <span>查看更多</span>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

function mapStateToProps(state,ownProps) {
  return {
    
  }
}

export default connect(mapStateToProps)(Recommend);


// WEBPACK FOOTER //
// ./src/components/recommend/Recommend.js